import React from 'react'

const Map = () => {
    return (
        <section className="bg-[#1e293b] text-white py-16 px-6">
            <div className="max-w-4xl mx-auto flex flex-col lg:flex-row justify-center items-center gap-12">
                {/* Texto */}
                <div className="flex-1 text-center">
                    <h2 className="text-3xl md:text-4xl font-bold mb-4">¿DÓNDE TRABAJAMOS?</h2>
                    <p className="text-white/80 text-lg mb-4">
                        Netmax tiene su sede en la localidad de Tancacha y realiza sus operaciones en los pueblos y ciudades aledañas sin limitarse a las mismas.
                    </p>
                    <p className="text-white/70">
                        No dude en consultarnos por obras en localidades más alejadas.
                    </p>
                </div>

                {/* Imagen */}
                <div className="flex-1">
                    <img
                        src="/images/home/mapa_rural.jpg"
                        alt="Zonas de cobertura Netmax"
                        className="rounded-xl w-full lg:w-3/4 h-auto object-cover object-center shadow-lg"
                    />
                </div>
            </div>
        </section>
    )
}
export default Map 